module.exports = __webpack_public_path__ + "static/media/partner.e3cea9cb.svg";